import { EcommerceIconComponent } from '../assets/icons/ecommerce';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'ecommerce',
  label: 'Loja Online',
  icon: EcommerceIconComponent()
};

export default generateResources(resource);
